import {deleteMethod, getMethod, postMethod} from '~/api'

async function get(contractId) {
    return await getMethod(`/api/ownProductContractFiles/${contractId}`)
}

async function post(contractId, request) {
    return await postMethod(`/api/ownProductContractFiles/${contractId}`, request)
}

async function remove(contractId, fileId) {
    return await deleteMethod(`/api/ownProductContractFiles/${contractId}/${fileId}`)
}

export {get, post, remove}
